module.exports = __webpack_public_path__ + "img/yiyao_zhongnongweite_suoluetu.9497be33.png";